module.exports = __webpack_public_path__ + "static/media/sh.2f258960.svg";